import { render, staticRenderFns } from "./galeryImageComponent.vue?vue&type=template&id=0c6a97d2&scoped=true"
import script from "./galeryImageComponent.vue?vue&type=script&lang=js"
export * from "./galeryImageComponent.vue?vue&type=script&lang=js"
import style0 from "./galeryImageComponent.vue?vue&type=style&index=0&id=0c6a97d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a97d2",
  null
  
)

export default component.exports